import React from 'react';

const Experience = () => {
  const appImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_77d4fb7f-ea31-43e7-ae50-21c238733199/artifacts/0x3sh9u9_WhatsApp%20Image%202026-03-03%20at%2019.38.44%20%281%29.jpeg',
      title: 'Chat with Divine Entities'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_77d4fb7f-ea31-43e7-ae50-21c238733199/artifacts/0uflhy6x_WhatsApp%20Image%202026-03-03%20at%2019.38.44%20%282%29.jpeg',
      title: 'Your Divine Feed'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_77d4fb7f-ea31-43e7-ae50-21c238733199/artifacts/1xpr1zbc_WhatsApp%20Image%202026-03-03%20at%2021.22.53.jpeg',
      title: 'Choose Your Companion'
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl cosmic-glow"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4 text-white">
            Feel the Presence. <span className="text-gradient">Experience the Divine.</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            A temple in your pocket, guidance at your fingertips
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {appImages.map((image, index) => (
            <div
              key={index}
              className={`group flex justify-center ${
                index === 0 ? 'phone-float' : 
                index === 1 ? 'phone-float-delay-1' : 
                'phone-float-delay-2'
              }`}
            >
              {/* Mobile Phone Frame */}
              <div className="relative w-[280px] h-[560px] bg-gradient-to-b from-gray-800 to-gray-900 rounded-[2.5rem] p-2.5 shadow-2xl phone-glow transform transition-all duration-300 hover:scale-105">
                {/* Phone Notch */}
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-3xl z-20"></div>
                
                {/* Screen Container */}
                <div className="relative w-full h-full bg-black rounded-[2rem] overflow-hidden">
                  {/* Glass border only - no blur */}
                  <div className="absolute inset-0 z-10 pointer-events-none">
                    <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-transparent border border-white/10 rounded-[2rem]"></div>
                  </div>
                  
                  {/* Image - crystal clear */}
                  <img 
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover relative z-0"
                  />
                  
                  {/* Title overlay on hover */}
                  <div className="absolute inset-0 z-20 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8">
                    <p className="text-white font-semibold text-base text-center px-4">{image.title}</p>
                  </div>
                </div>
                
                {/* Phone Button */}
                <div className="absolute bottom-1.5 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gray-700 rounded-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;